module.exports = __webpack_public_path__ + "img/HomepageBannerBackgroundHeaderMobile.d1e47903.png";